export const failedAttempts = [
  {
    title: 'Las pastillas',
    body: 'Solo silencian la alarma, pero el incendio —la compresión del disco— sigue quemando el nervio.',
  },
  {
    title: 'El reposo total en el sofá',
    body: 'Las superficies blandas aumentan la presión intradiscal y debilitan los músculos que deberían sostenerte.',
  },
  {
    title: 'Los estiramientos agresivos',
    body: 'Yoga o gimnasio traccionan un nervio ya irritado: micro-desgarros y más inflamación.',
  },
  {
    title: 'El calor en las primeras 48 horas',
    body: 'Dilata los vasos sanguíneos y aumenta la presión dentro del canal estrecho de la columna.',
  },
]

export const method = [
  {
    letter: 'R',
    name: 'Respirar',
    body: 'La respiración diafragmática apaga el sistema de alerta del dolor y suelta la tensión de protección.',
  },
  {
    letter: 'I',
    name: 'Isolar',
    body: 'Posicionamos la pelvis para que el psoas deje de tirar de tus lumbares y libere la zona comprimida.',
  },
  {
    letter: 'A',
    name: 'Aflojar',
    body: 'La gravedad separa tus vértebras milímetro a milímetro: vuelve el flujo sanguíneo, se apaga el dolor.',
  },
]

export const deliverables = [
  {
    title: 'La Guía Digital Maestra',
    body: 'Protocolo completo de alivio para hernia y ciática en formato PDF, listo para leer en cualquier dispositivo.',
  },
  {
    title: 'El Mapa de Posiciones de Emergencia',
    body: 'Ilustraciones claras de cómo liberar el nervio en 3 minutos, paso a paso.',
  },
  {
    title: 'El Guion de Respiración Diafragmática',
    body: 'La secuencia exacta para apagar el sistema de alerta del dolor.',
  },
  {
    title: 'La Lista de "Banderas Rojas"',
    body: 'Cuándo es una emergencia real y cuándo puedes sanar tranquilo en casa.',
  },
  {
    title: 'Bonus: Guía "Noches Sin Dolor"',
    body: 'Las 3 posturas para dormir según tu tipo de lesión.',
  },
]

export const forWho = [
  'Hispanos en USA que trabajan largas horas de pie o manejando.',
  'Personas con diagnóstico de hernia L4-L5 o L5-S1 que quieren evitar la cirugía.',
  'Cualquiera que sienta hormigueo, debilidad o un "corrientazo" que baja por el glúteo.',
  'Padres o abuelos que ya no pueden cargar a sus niños por miedo a que se les "trabe" la espalda.',
]

export const notForWho = [
  'Personas con fracturas recientes de columna o tumores.',
  'Casos de "Cauda Equina" (pérdida de control de esfínteres): requieren hospital inmediato.',
  'Quienes buscan una cura milagrosa sin hacer 5 minutos de posiciones diarias.',
]

export const steps = [
  {
    title: 'Descarga el manual',
    body: 'En tu celular o tablet, con acceso instantáneo después del pago.',
  },
  {
    title: 'Elige la Posición de Rescate #1',
    body: 'Según tu nivel de dolor actual, sin equipo especial.',
  },
  {
    title: 'Mantén la posición 5 a 10 minutos',
    body: 'Siguiendo la técnica de respiración guiada del protocolo.',
  },
]

export const faqs = [
  {
    q: '¿Necesito equipo especial?',
    a: 'No. Solo una silla, una toalla y el suelo de tu casa.',
  },
  {
    q: '¿Tengo que dejar de trabajar?',
    a: 'No. Te enseñamos a hacer "snacks de movimiento" de 1 minuto para protegerte mientras trabajas.',
  },
  {
    q: '¿Es seguro si tengo una hernia diagnosticada?',
    a: 'Sí. El protocolo se basa en posiciones neutras que eliminan la carga sobre el disco.',
  },
]
